import { AllFacetsScopes, FacetTypes } from "../../facets/Facets";

/** Control next to a label to clear the associated filter. */
export default class LayerBackButton {
  /** @type {string} Facet ID to clear on click. */
  facetId;
  /** @type {?(SpaceLabel|LevelLabel)} Label to host the back button on the side of. */
  hostLabel;
  /** @type {HTMLDivElement} HTML element of the button. */
  el;

  constructor(facetsManager, document, facetId, itemId) {
    this.facetId = facetId;

    const el = document.createElement('div');
    el.innerHTML = "<svg width='11px' height='11px' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><path d='m3 3 18 18M3 21 21 3' stroke-width='4' stroke='currentColor'/></svg>";
    el.classList.add('adsk-button-layer-back');

    el.addEventListener('click', (event) => {

      facetsManager.setVisibilityById(facetId, itemId, false, false, AllFacetsScopes);

      this.hostLabel.setSelected(false);

      event.preventDefault();
      event.stopPropagation();
    });

    const elWrap = document.createElement("div");
    elWrap.style.padding = "0";
    elWrap.style.margin = "0";
    elWrap.style.lineHeight = "16px";
    elWrap.appendChild(el);
    elWrap.style.display = "none";
    elWrap.title = "Clear this filter";

    this.el = elWrap;
  }

  /**
   * Adds a back button next to the passed-in label.
   * @param {?(SpaceLabel|LevelLabel)} label Label or null to detach.
   */
  attachTo(label) {

    // Skipping as the DOM label is not yet available.
    if (!label.label) return;

    const container = label.label.container;
    container.insertBefore(this.el, container.children[0]);

    this.hostLabel = label;
  }

  /**
   * Adds a back button next to the passed-in label.
   * @param {LabelUI} label
   */
  attachToUI(ui) {

    const container = ui.labelHost;
    container.insertBefore(this.el, ui.textHost);

    this.hostLabel = ui;
  }

  show() {
    this.el.style.display = "inline";
  }

  hide() {
    this.el.style.display = "none";
  }

}